import React, { useState } from 'react'
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import ContentHtml from '../../../../components/content/ContentHtml/ContentHtml.component'

export const VanityDomainInstructions = () => {
  const [isOpenModal, setIsOpenModal] = useState(false)
  return (
    <>
      <MDBBtn type='button' color='indigo' onClick={() => setIsOpenModal(true)} className='mt-5 mx-0 btn-block'>
        Vanity Domain Instructions
      </MDBBtn>
      <MDBModal open={isOpenModal} tabIndex='-1' onClose={() => setIsOpenModal(false)}>
        <MDBModalDialog size='md'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Vanity Domain Instructions</MDBModalTitle>
              <MDBBtn type='button' className='btn-close' color='none' onClick={() => setIsOpenModal(false)}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <ContentHtml contentSlug='subsite-vanity-domain-howto' />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  )
}
